module.exports = __webpack_public_path__ + "img/59.c0281e41.jpg";